<div class="p-6 gap-4 bg-white p-6 rounded-lg shadow">
  <h2>{{ 'projectBiddingForm.title' | translate }} - {{ ('projectBiddingForm.mode' + (mode | titlecase)) | translate }}</h2>

  <div class="flex gap-4 mb-4">
    <button mat-stroked-button color="primary" *ngIf="mode === 'add'" (click)="setMode('add')">
      {{ 'projectBiddingForm.modeAdd' | translate }}
    </button>
    <button mat-stroked-button color="primary" *ngIf="mode === 'view'" (click)="setMode('edit')">
      {{ 'projectBiddingForm.modeEdit' | translate }}
    </button>
    <button mat-stroked-button color="accent" *ngIf="mode === 'edit'" (click)="setMode('view')">
      {{ 'projectBiddingForm.modeView' | translate }}
    </button>
  </div>

  <form [formGroup]="biddingForm" (ngSubmit)="onSubmit()" class="grid grid-cols-12 gap-6" novalidate>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.clientName' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="clientName" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
    <mat-label>{{ 'projectBiddingForm.address' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="address" />
      </mat-form-field>
    </div>
       <div class="col-span-6">
    <mat-label>{{ 'projectBiddingForm.logo' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="logo" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
    <mat-label>{{ 'projectBiddingForm.contactName' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="contactName" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.clientCode' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="clientCode" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
    <mat-label>{{ 'projectBiddingForm.email' | translate }}</mat-label>



      <mat-form-field appearance="outline">
        <input matInput formControlName="email" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.mobile' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="mobile" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>{{ 'projectBiddingForm.project' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="project_id">
          <mat-option *ngFor="let project of projectData" [value]="project.id ?? project.project_id">{{
            project.project_name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>{{ 'projectBiddingForm.projectType' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="projectType">
          <mat-option *ngFor="let opt of projectTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.locationAddress' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="locationAddress" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>{{ 'projectBiddingForm.latLongStart' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="latLongStart" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>{{ 'projectBiddingForm.latLongEnd' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="latLongEnd" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
<mat-label>{{ 'projectBiddingForm.totalScope' | translate }}</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="totalScope" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
    <mat-label>{{ 'projectBiddingForm.segmentsLatLongs' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <textarea matInput formControlName="segmentsLatLongs"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-6">
    <mat-label>{{ 'projectBiddingForm.segmentDescription' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <textarea matInput formControlName="segmentDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.workDescription' | translate }}</mat-label>

      <mat-form-field appearance="outline">
        <textarea matInput formControlName="workDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.bidStartDate' | translate }}</mat-label>

      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="bidStartPicker" formControlName="bidStartDate" />
        <mat-datepicker-toggle matSuffix [for]="bidStartPicker"></mat-datepicker-toggle>
        <mat-datepicker #bidStartPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>{{ 'projectBiddingForm.bidEndDate' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="bidEndPicker" formControlName="bidEndDate" />
        <mat-datepicker-toggle matSuffix [for]="bidEndPicker"></mat-datepicker-toggle>
        <mat-datepicker #bidEndPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.vendors' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <mat-select formControlName="vendors" multiple>
          <mat-option *ngFor="let vendor of vendorsList" [value]="vendor">{{
            vendor
            }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    <div class="col-span-6">
     <mat-label>{{ 'projectBiddingForm.bidPackageSentDate' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="pkgDate" formControlName="bidPackageSentDate" />
        <mat-datepicker-toggle matSuffix [for]="pkgDate"></mat-datepicker-toggle>
        <mat-datepicker #pkgDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-span-6">
   <mat-label>{{ 'projectBiddingForm.bidFees' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <input matInput formControlName="bidFees" />
      </mat-form-field>
    </div>
      <div class="col-span-12">
      <mat-label>{{ 'projectBiddingForm.supplierContacts' | translate }}</mat-label>


      <mat-form-field appearance="outline">
        <textarea matInput formControlName="supplierContacts"></textarea>
      </mat-form-field>
    </div>
    <div class="form-actions" *ngIf="mode !== 'view'">
      <button mat-raised-button color="primary" type="submit">{{ 'projectBiddingForm.submit' | translate }}</button>
    </div>
  </form>
</div>